<template>
    <div class="commercial">
        <el-container>
            <el-aside class="aside" width="250px" style="background-color: rgb(238, 241, 246)">
                <el-input type="text" placeholder="搜索分类名称" v-model="serchvalue" @change="serchasideHandel" style="margin-bottom:10px"></el-input>
                <div v-loading="categoryLoading" element-loading-text="加载中..." style="min-height: 100px;">
                    <div class="aside_child" :class="{'checkbgc': item.id == checkindex}" v-for=" item in leftcategory" :key="item.id"
                         @click="checkedaside(item.id)">
                        <div class="top_text">
                            <div class="child_title">{{ item.name }}</div>
                            <div class="child_btn">
                                <el-button type="text" @click="complieasideHandel(item)">编辑</el-button>
                                <el-button type="text" style="color: red;" @click.stop="unclassify(item)">{{ item.status==1?'下架':'上架' }}</el-button>
                                <el-button type="text" style="color: red;" @click.stop="deleteclasssify(item)">删除</el-button>
                            </div>
                        </div>
                        <div class="parameter">
                            <div class="people_num" v-if="item.id == checkindex">{{ type==1?'课程量':'文章量' }}：{{ item.course_nums }}</div>
                            <div class="stor_num" v-if="item.id == checkindex && item.sort">排序：{{ item.sort }}</div>
                        </div>
                    </div>
                </div>
                <el-button type="primary" size="mini" class="addclassify" @click="openasideHandel">添加分类</el-button>
                <!-- <el-button type="info" size="mini" class="addclassify" v-else>添加分类</el-button> -->
            </el-aside>

            <el-container class="el_container">
                <el-header style="font-size: 12px;height: auto;">
                    <el-input class="search-el" size="mini" v-model="query.title" clearable placeholder="请输入课程名称" v-if="type == 1"></el-input>
                    <el-input class="search-el" size="mini" v-model="query.title" clearable placeholder="请输入文章名称" v-else></el-input>
                    <el-select class="search-el" size="mini" v-model="query.status" clearable placeholder="上架状态">
                        <el-option label="全部" value="">全部</el-option>
                        <el-option label="已上线" value="1">已上线</el-option>
                        <el-option label="已下线" value="2">已下线</el-option>
                    </el-select>
                    <el-date-picker size="mini" v-model="query.created_at_begin" type="date" value-format="yyyy-MM-dd" placeholder="创建开始时间">
                    </el-date-picker>
                    ~
                    <el-date-picker size="mini" v-model="query.created_at_end" type="date" value-format="yyyy-MM-dd" placeholder="创建结束时间">
                    </el-date-picker>
                    <el-date-picker class="statusat" size="mini" v-model="query.online_time_begin" type="date" value-format="yyyy-MM-dd" placeholder="上线开始时间">
                    </el-date-picker>
                    ~
                    <el-date-picker size="mini" v-model="query.online_time_end" type="date" value-format="yyyy-MM-dd" placeholder="上线结束时间">
                    </el-date-picker>
                    <el-button type="primary" size="mini" @click="getList" style="margin-left: 20px;" v-if="!isbutton"> 搜索</el-button>
                    <el-button type="info" size="mini" style="margin-left: 20px;" v-if="isbutton"> 搜索</el-button>
                        <el-button type="primary" size="mini" @click="toCreate(type)" v-if="!isbutton && type==1"> 新建课程</el-button>
                        <el-button type="info" size="mini" v-if="isbutton && type==1"> 新建课程</el-button>
                        <el-button type="primary" size="mini" @click="toCreate(type)" v-if="!isbutton && type!= 1"> 新建文章</el-button>
                        <el-button type="info" size="mini" v-if="isbutton && type != 1"> 新建文章</el-button>
                   
                </el-header>

                <el-main>
                <div v-loading="loading" element-loading-text="加载中" style="min-height: 300px;">
                    <div class="main_row" v-if="isEmpty">
                        <div class="row_box" v-for="item in Infolist" :key="item.id">
                                <el-checkbox v-model="item.checked" @change="itemcheckHandel(item)"></el-checkbox>
                                <div class="row_center">
                                    <div class="row_title">{{ item.title }}</div>
                                    <div class="row_one">
                                        <div :style="{color: item.status==1 ? '#409eff':'red'}">{{ item.status==1?'已上线':'已下线' }}</div>
                                        <div>浏览次数：{{ item.visitor_num }}</div>
                                        <div>收藏次数：{{ item.collect_num }}</div>
                                    </div>
                                    <div class="row_tow">
                                        <div>排序：{{ item.sort }}</div>
                                        <div>创建人：{{ item.created_admin }}</div>
                                        <div>创建时间：{{ item.created_at }}</div>
                                        <div v-if="item.released_at && item.status==1">上线时间：{{ item.released_at }}</div>
                                    </div>
                                </div>
                                <div class="row_right">
                                    <el-button type="text" v-if="type==1" :style="{color: item.recommend_status==0 ? '#409eff':'red'}" @click="updateRecommendStatus(item.id, item.recommend_status)">{{ item.recommend_status==1?'取消推荐':'推荐' }}</el-button>
                                    <el-button type="text" @click="gocomplieHandel(item)">编辑</el-button>
                                    <el-button type="text" :style="{color: item.status==2 ? '#409eff':'red'}" @click="poporupHandel(item)">{{ item.status==1?'下线':'上线' }}</el-button>
                                    <el-button type="text" style="color: red;" @click="opendeldialog(item)">删除</el-button>
                                </div>
                            </div>
                        </div>
                        <el-empty description="暂无数据" v-if="!isEmpty"></el-empty>
                    </div>
                </el-main>
                <el-footer>
                    <el-checkbox v-model="checkedAll" @change="toggleAllItems" :disabled="isbutton || !isEmpty">全选</el-checkbox>
                    <el-button type="text" style="margin-left: 10px;" v-if="isShow" @click="popallHandel" :disabled="isbutton|| !isEmpty">批量上线</el-button>
                    <el-button type="text" style="color: red;" v-if="isShow" @click="unallHandel" :disabled="isbutton|| !isEmpty">批量下线</el-button>
                    <el-button type="text" style="color: red;" v-if="isShow" @click="openalldeldialog" :disabled="isbutton|| !isEmpty">批量删除</el-button>
                </el-footer>
            </el-container>
        </el-container>
        <el-dialog title="添加分类" :visible.sync="addclassdialogVisible" width="30%" center @close="clossddclassdialogVisible">
            <el-form :model="adept" label-width="100px" class="demo-adept">
                <el-form-item label="分类名称" class="is-required">
                    <el-input v-model="adept.name" class="redactinput" maxlength="10" placeholder="请填写分类名称"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="adept.sort" class="redactinput" type="number" placeholder="请填写排序"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clossddclassdialogVisible" style="margin-right: 30px;">取 消</el-button>
                <el-button type="primary" @click="addClassHandel">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑分类" :visible.sync="compileclassdialogVisible" width="30%" center>
            <el-form :model="complieform" label-width="100px" class="demo-adept">
                <el-form-item label="分类名称" class="is-required">
                    <el-input v-model="complieform.name" class="redactinput" maxlength="10" placeholder="请填写分类名称"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="complieform.sort" class="redactinput" type="number" placeholder="请填写排序"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="compileclassdialogVisible = false" style="margin-right: 30px;">取 消</el-button>
                <el-button type="primary" @click="complieClassHandel">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="unclassifydialogVisible" width="30%" center>
            <div style="text-align: center; font-weight: 600; font-size: 16px;">是否确认{{ statustype==1?'下架':'上架' }}此分类？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="unclassifydialogVisible = false" style="margin-right: 30px;">取 消</el-button>
                <el-button type="primary" @click="unclassifyHandel">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="delclassifydialogVisible" width="30%" center>
            <div style="text-align: center; font-weight: 600; font-size: 16px;">是否确认删除此分类？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delclassifydialogVisible = false" style="margin-right: 30px;">取 消</el-button>
                <el-button type="primary" @click="delclassifyHandel">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="uncoursedialogVisible" width="30%" center>
            <div style="text-align: center; font-weight: 600; font-size: 16px;">是否确认将<span>{{  type==1?'课程':'文章' }}</span>{{ popuptype==1?'下线':'上线' }}？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uncoursedialogVisible = false" style="margin-right: 30px;">取 消</el-button>
                <el-button type="primary" @click="uncourseHandel">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="delcoursealldialogVisible" width="30%" center>
            <div style="text-align: center; font-weight: 600; font-size: 16px;">是否确认将<span>{{  type==1?'课程':'文章' }}</span>删除？？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delcoursealldialogVisible = false" style="margin-right: 30px;">取 消</el-button>
                <el-button type="primary" @click="delcourseallHandel">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="delcoursedialogVisible" width="30%" center>
            <div style="text-align: center; font-weight: 600; font-size: 16px;">是否确认将<span>{{  type==1?'课程':'文章' }}</span>删除？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delcoursedialogVisible = false" style="margin-right: 30px;">取 消</el-button>
                <el-button type="primary" @click="delcourseHandel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getcategoryList,
    createUpdate,
    delcategory,
    courselist,
    coursedel,
    coursesttusupdate,
    courseRecommendUpdate,
} from "@/api/commerciam";
export default {
    name: "",
    data() {
        return {
            type: 1,
            list: [],
            categoryList: [],
            checkindex: '',
            loading: false,
            categoryLoading: false,
            serchvalue: '', // 添加搜索框的值
            query: {
                category_id: '',
                keyword: '',
                status: '',
                page: 1,
                page_size: 20,
                title: '', // 课程/文章名称搜索
                created_at_begin: '', // 创建开始时间
                created_at_end: '', // 创建结束时间
                online_time_begin: '', // 上线开始时间
                online_time_end: '' // 上线结束时间
            },
            checkedAll: false,
            addclassdialogVisible: false,
            unclassifydialogVisible: false, // 下架分类
            compileclassdialogVisible: false,
            delclassifydialogVisible: false,
            delcoursedialogVisible: false,
            uncoursedialogVisible: false,
            delcoursealldialogVisible: false,
            adept: {
                name: "",
                sort: "",
                type:'',
            },
            leftcategory: [], // 分类列表
            statustype: null, // 上下架状态
            checkindex: 0,
            isShow: false,
            complieform: {
                name: "",
                sort: "",
                id: null,
            },
            checkaside: {},
            checkcourse: {},
            Infolist: [],
            uncourselist: [], // 上下线数组
            delcourselist: [], // 删除数组
            unoption: {},
            popuptype: null,
            kind: "",
            isbutton: false,
            isEmpty: false,
            type:1,
        };
    },
    created(){
        this.type= this.$route.query.type
        console.log(this.type,'route');
        this.adept.type =  this.type
        
    },
    mounted() {
        this.getcategoryListHandel().then(() => {
            if (this.leftcategory.length > 0) {
                // 从localStorage获取保存的分类ID，如果存在且有效则使用，否则使用第一个
                const savedCategoryId = localStorage.getItem(`selectedCategory_${this.type}`);
                if (savedCategoryId && this.leftcategory.some(item => item.id == savedCategoryId)) {
                    this.checkindex = this.query.category_id = savedCategoryId;
                } else {
                    this.checkindex = this.query.category_id = this.leftcategory[0].id;
                    // 保存默认分类到localStorage
                    localStorage.setItem(`selectedCategory_${this.type}`, this.leftcategory[0].id);
                }
                this.getList();
            }
        });
    },
    watch: {
        Infolist: {
            handler() {
                if (this.Infolist.length > 0) {
                    this.checkedAll = this.Infolist.every(
                        (item) => item.checked
                    );
                    this.isShow = this.Infolist.some((item) => item.checked);
                } else {
                    this.checkedAll = false;
                    this.isShow = false;
                }
            },
            deep: true,
        },
        leftcategory: {
            handler() {
                if (this.leftcategory.length == 0) {
                    this.Infolist = [];
                }
            },
            deep: true,
        },
    },
    methods: {
        poporupHandel(item) {
            this.checkcourse = item;
            this.kind = 1;
            this.uncoursedialogVisible = true;
            this.popuptype = item.status;
            this.uncourselist = [];
            this.uncourselist.push(item.id);
        },
        uncourseHandel() {
            // 确认课程上下线
            if (this.kind == 1) {
                this.unoption = {
                    id: this.uncourselist,
                    status: this.checkcourse.status == 1 ? 2 : 1,
                };
            } else if (this.kind == 2) {
                this.unoption = {
                    id: this.uncourselist,
                    status: (this.checkcourse.status = 1),
                };
            } else {
                this.unoption = {
                    id: this.uncourselist,
                    status: (this.checkcourse.status = 2),
                };
            }

            // console.log(this.unoption);
            coursesttusupdate(this.unoption).then((res) => {
                if (res.code == 1) {
                    this.$message({
                        message: "操作成功!",
                        type: "success",
                    });
                    this.uncoursedialogVisible = false;
                    this.getList();
                    this.uncourselist = [];
                    this.delcourselist = []
                }
            });
        },
        uncourseallHandel() {
            let option = {
                id: this.delcourselist,
            };
            if (this.checkcourse.status == 1) {
                this.$message({
                    message:this.type==1?'课程':'文章'+"已上线，不可操作!",
                    type: "error",
                });
                this.delcoursedialogVisible = false;
                this.delcourselist = [];
            } else {
                coursedel(option).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            message: "操作成功!",
                            type: "success",
                        });
                        this.delcoursedialogVisible = false;
                        this.getList();
                        this.delcourselist = [];
                        this.getcategoryListHandel()
                    }
                });
            }
        },
        opendeldialog(item) {
            this.checkcourse = item;
            this.delcoursedialogVisible = true;
            this.delcourselist = [];
            this.delcourselist.push(item.id);
        },
        delcourseHandel() {
            // 确认将课程删除
            let option = {
                id: this.delcourselist,
            };
            let text = this.type==1?'课程':'文章'
            if (this.checkcourse.status == 1) {
                this.$message({
                    message: text+"已上线，不可操作!",
                    type: "error",
                });
                this.delcoursedialogVisible = false;
                this.delcourselist = [];
            } else {
                coursedel(option).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            message: "操作成功!",
                            type: "success",
                        });
                        this.delcoursedialogVisible = false;
                        this.getList();
                        this.delcourselist = [];
                        this.getcategoryListHandel()
                    }
                });
            }
        },
        popallHandel() {
            // 批量上线
            // console.log(this.checkIfAnyChecked());
            if (this.checkIfAnyChecked()) {
                // this.unoption.status = 2
                // this.uncourseHandel()
                this.popuptype = 2;
                this.kind = 2;
                this.uncoursedialogVisible = true;
            } else {
                this.$message({
                    message: "请选择"+this.type==1?'课程':'文章',
                    type: "error",
                });
            }
        },
        unallHandel() {
            // 批量下线
            if (this.checkIfAnyChecked()) {
                this.popuptype = 1;
                this.kind = 3;
                // this.unoption.status = 1
                this.uncoursedialogVisible = true;
            } else {
                this.$message({
                    message: "请选择"+this.type==1?'课程':'文章',
                    type: "error",
                });
            }
        },
        openalldeldialog() {
            this.delcoursealldialogVisible = true;
        },
        delcourseallHandel() {
            console.log(this.checkIfAnyStatusOne(),this.delcourselist);
            if (this.checkIfAnyStatusOne()) {
                this.$message({
                    message: "有"+this.type==1?'课程':'文章'+"已上线，不可操作!",
                    type: "error",
                });
                this.delcoursealldialogVisible = false;
                // this.delcourselist = [];
            } else {
                let option = {
                    id: this.delcourselist,
                };
                coursedel(option).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            message: "操作成功!",
                            type: "success",
                        });
                        this.delcoursealldialogVisible = false;
                        this.getList();
                        this.delcourselist = [];
                        this.getcategoryListHandel()
                    }
                });
            }
        },
        checkIfAnyChecked() {
            const anyChecked = this.Infolist.some((item) => item.checked);
            return anyChecked;
        },
        checkIfAnyStatusOne() {
            const anyStatusOne = this.Infolist.some(
                (item) => item.checked && item.status == 1
            );
            return anyStatusOne;
        },
        complieasideHandel(item) {
            // 打开编辑分类弹窗
            this.compileclassdialogVisible = true;
            this.complieform.name = item.name;
            this.complieform.sort = item.sort;
            this.complieform.id = item.id;
        },
        complieClassHandel() {
            if (this.complieform.name == "") {
                this.$message({
                    message: "分类名称不能为空!",
                    type: "error",
                });
                return;
            }
            if (this.complieform.sort.length > 0 && this.complieform.sort != '') {
                // 检查值是否不为 null 和 undefined
                let intnum = Number(this.complieform.sort);
                if (Number.isInteger(intnum) && intnum > 0) {
                    // 如果是正整数，执行相关操作
                    createUpdate(this.complieform).then((res) => {
                        if (res.code == 1) {
                            this.$message({
                                message: "编辑成功!",
                                type: "success",
                            });
                            this.compileclassdialogVisible = false;
                            this.getcategoryListHandel();
                        }
                    });
                } else {
                    // 如果不是正整数，可以选择执行其他操作或不执行任何操作
                    this.$message({
                        message: "排序请输入正整数!",
                        type: "error",
                    });
                    return;
                    // 提交编辑
                }
            } else {
                // 如果值为空（即 null 或 undefined），执行下一步操作
                createUpdate(this.complieform).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            message: "编辑成功!",
                            type: "success",
                        });
                        this.compileclassdialogVisible = false;
                        this.getcategoryListHandel();
                    }
                });
            }
        },
        toggleAllItems() {
            // quanxuan
            this.Infolist.forEach((item) => {
                item.checked = this.checkedAll;
            });
            if (this.checkedAll) {
                this.uncourselist = this.Infolist.map((item) => item.id);
                this.delcourselist = this.Infolist.map((item) => item.id);
            } else {
                this.uncourselist = [];
                this.delcourselist = [];
            }
            this.isShow = this.checkedAll;
            console.log(this.uncourselist,this.delcourselist ,'all');
        },
        itemcheckHandel(checkbox) {
            // console.log(id);
            if (checkbox.checked) {
            // 如果复选框被选中，则将其 ID 加入数组
            if (!this.uncourselist.includes(checkbox.id)) {
                this.uncourselist.push(checkbox.id);
            }
            if (!this.delcourselist.includes(checkbox.id)) {
                this.delcourselist.push(checkbox.id);
            }
           
        } else {
            // 如果复选框被取消选中，则从数组中移除其 ID
            let index = this.delcourselist.indexOf(checkbox.id);
            let index2 = this.uncourselist.indexOf(checkbox.id);
            if (index !== -1) {
                this.delcourselist.splice(index, 1);
            }
            if (index2 !== -1) {
                this.uncourselist.splice(index, 1);
            }
        }
console.log(this.delcourselist,this.uncourselist,'danxuan');
        },
        getList() {
            // 列表数据
            this.loading = true;
            courselist(this.query).then((res) => {
                if (res.code == 1) {
                    this.Infolist = res.data;
                    if (this.Infolist.length != 0) {
                        this.Infolist.forEach((item) => {
                            if (!item.hasOwnProperty("checked")) {
                                this.$set(item, "checked", false); // 添加 checked 属性并初始化为 false
                            }
                        });
                        this.isEmpty = true;
                    } else {
                        this.isEmpty = false;
                    }

                    // console.log(this.Infolist);
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        getcategoryListHandel() {
            // 分类数据
            this.categoryLoading = true;
            return new Promise((resolve, reject) => {
                getcategoryList({ name: this.serchvalue,type:this.type }).then((res) => {
                    if (res.code == 1) {
                        this.leftcategory = res.data;
                        // this.checkindex = res.data[0].id
                        if (this.leftcategory.length == 0) {
                            this.isbutton = true;
                        } else {
                            this.isbutton = false;
                        }
                        if (this.leftcategory.length == 1) {
                            this.checkindex = this.leftcategory[0].id;
                        }
                        // console.log(this.isbutton,'[[[[[[[[]]]]]]]]');
                    }
                    this.categoryLoading = false;
                    resolve();
                }).catch(() => {
                    this.categoryLoading = false;
                    reject();
                });
            });
        },
        toCreate(type) {
            // 新建课程
            if(type == 1){
                this.$router.push(
                `/commercial/info?category_id=${this.checkindex}`
            );
            }else{
                this.$router.push(
                `/commercial/articleinfo?category_id=${this.checkindex}`
            );
            }
        },
        gocomplieHandel(item) {
            // 课程编辑
            if(this.type == 1){
                this.$router.push(
                `/commercial/info?id=${item.id}&category_id=${this.checkindex}`
            );
            }else{
                this.$router.push(
                `/commercial/articleinfo?id=${item.id}&category_id=${this.checkindex}`
            );
            }

        },
        checkedaside(index) {
            // 选中分类并保存到localStorage
            this.checkindex = index;
            this.query.category_id = index;
            localStorage.setItem(`selectedCategory_${this.type}`, index);
            this.uncourselist = [];
            this.delcourselist = [];
            this.getList();
        },
        serchasideHandel() {
            // 分类搜索
            // console.log(this.serchvalue);
            this.getcategoryListHandel().then(() => {
                // 搜索完成后，如果有搜索结果，选中第一个分类并加载课程列表
                if (this.leftcategory.length > 0) {
                    this.checkindex = this.leftcategory[0].id;
                    this.query.category_id = this.checkindex;
                    this.getList();
                } else {
                    // 如果没有搜索结果，清空课程列表
                    this.Infolist = [];
                    this.isEmpty = false;
                }
            });
        },
        openasideHandel() {
            // 打开添加分类弹窗
            this.addclassdialogVisible = true;
        },
        clossddclassdialogVisible() {
            this.addclassdialogVisible = false;
            this.adept.name = "";
            this.adept.sort = "";
        },
        addClassHandel() {
            // 添加分类
            if (this.adept.name == "") {
                this.$message({
                    message: "分类名称不能为空!",
                    type: "error",
                });
                return;
            }
            if (this.adept.sort.length > 0 && this.adept.sort != '') {
                // 检查值是否不为 null 和 undefined
                let intnum = Number(this.adept.sort);
                if (Number.isInteger(intnum) && intnum > 0) {
                    // 如果是正整数，执行相关操作
                    createUpdate(this.adept).then((res) => {
                if (res.code == 1) {
                    this.$message({
                        message: "添加成功!",
                        type: "success",
                    });
                    this.addclassdialogVisible = false;
                    this.adept.name = "";
                    this.adept.sort = "";
                    this.getcategoryListHandel();
                }
            });
                } else {
                    // 如果不是正整数，可以选择执行其他操作或不执行任何操作
                    this.$message({
                        message: "排序请输入正整数!",
                        type: "error",
                    });
                    return;
                    // 提交编辑
                }
            } else {
                // 如果值为空（即 null 或 undefined），执行下一步操作
                createUpdate(this.adept).then((res) => {
                if (res.code == 1) {
                    this.$message({
                        message: "添加成功!",
                        type: "success",
                    });
                    this.addclassdialogVisible = false;
                    this.adept.name = "";
                    this.adept.sort = "";
                    this.getcategoryListHandel();
                }
            });
            }

        },
        unclassify(status) {
            // 打开上下架弹窗

            this.statustype = status.status;
            this.checkaside = status;
            this.unclassifydialogVisible = true;
        },
        unclassifyHandel() {
            // 确认上下架分类
            let options = {
                id: this.checkaside.id,
                status: this.checkaside.status == 1 ? 2 : 1,
            };
            createUpdate(options).then((res) => {
                if (res.code == 1) {
                    this.$message({
                        message: "操作成功!",
                        type: "success",
                    });
                    this.unclassifydialogVisible = false;

                    this.getcategoryListHandel();
                }
            });
        },
        deleteclasssify(item) {
            // 删除分类
            this.delclassifydialogVisible = true;
            this.checkaside = item;
        },
        delclassifyHandel() {
            // 确认删除
            delcategory(this.checkaside).then((res) => {
                if (res.code == 1) {
                    this.$message({
                        message: "删除成功!",
                        type: "success",
                    });
                    this.delclassifydialogVisible = false;
                    this.getcategoryListHandel().then(() => {
                        if (this.checkaside.id == this.checkindex) {
                            //如果是选中的分类就默认选择更新列表后的第一个
                            if (this.leftcategory.length > 0) {
                                this.checkindex = this.query.category_id = this.leftcategory[0].id;
                                localStorage.setItem(`selectedCategory_${this.type}`, this.leftcategory[0].id);
                                this.getList();
                            }
                        }
                    });
                }
            });
        },
        updateRecommendStatus(id, recommend_status) {
          recommend_status = recommend_status ? 0 : 1;
          courseRecommendUpdate({'id':id, 'recommend_status':recommend_status}).then((res) => {
            if (res.code == 1) {
              this.$message({
                message: "操作成功!",
                type: "success",
              });
              this.getList();
            }
          });
        }
    },
};
</script>

<style>
body {
    padding: 0;
    margin: 0;
}
.commercial {
    position: relative;
    height: 100vh;
}
.commercial .el-empty {
    position: absolute; /* 子元素设置为绝对定位 */
    top: 50%; /* 50% 的垂直位置 */
    left: 50%; /* 50% 的水平位置 */
    transform: translate(-50%, -50%);
}
.el-container {
    box-sizing: border-box;
    height: 100%;
    /* min-width: 80%; */
}
.el-main::-webkit-scrollbar {
    width: 0;
    height: 0;
    /* 设置滚动条的宽度 */
}
.commercial .el-header {
    background-color: rgb(238, 241, 246);
    color: #333;
    line-height: 60px;
    /* display: flex; */
}

.commercial .el-aside {
    color: #333;
}
.aside {
    /* font-size: 16px; */
    padding: 5px;
}
.aside_child {
    /* height: 50px; */
    /* background-color: #fff; */
    padding: 7px 5px;
    margin-top: 5px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
}
.checkbgc {
    background-color: #fff;
}
.top_text {
    font-size: 16px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
}
.child_title {
    width: 110px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
}
.child_btn .el-button {
    padding: 0;
}
.addclassify {
    width: 100px;
    margin: 5px;
}
.parameter {
    display: flex;
    font-size: 14px;
    margin-top: 13px;
}
.stor_num {
    margin-left: 20px;
}
.el-header .el-date-editor.el-input {
    width: 150px;
}
.statusat {
    margin-left: 20px;
}
.main_row {
    display: flex;
    flex-direction: column;
}
.main_row .row_box {
    display: flex;
    border-bottom: 1px solid #ccc;
    padding: 10px 0;
}
.row_center {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
}
.row_center .row_title {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.row_one,
.row_tow,
.row_right {
    display: flex;
}
.row_right {
    margin-left: auto;
}
.row_one {
    margin: 10px 0;
}
.row_one div,
.row_tow div {
    margin-right: 10px;
}
.el_container .el-footer {
    background-color: rgb(238, 241, 246);
    display: flex;
    align-items: center;
}
.commercial .el-dialog__body {
    padding: 10px 25px;
}
</style>
